import { render, staticRenderFns } from "./SalonSubtitle.vue?vue&type=template&id=4e1f8584&scoped=true&"
import script from "./SalonSubtitle.vue?vue&type=script&lang=js&"
export * from "./SalonSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./SalonSubtitle.vue?vue&type=style&index=0&id=4e1f8584&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1f8584",
  null
  
)

export default component.exports